// extracted by mini-css-extract-plugin
module.exports = {"loader-overlay":"loader-overlay__203M5","spinner":"spinner__2mdgw"};